import React, { Component } from 'react';
import Icon from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/fontawesome-free-brands';
import { faPhone } from '@fortawesome/fontawesome-free-solid';

import contactImage from '../photos/contact.jpg';

class Contact extends Component {
  render() {
    return (
      <div className="contact">
        <div className="contact-card">
          <div className="contact-photo-wrapper">
            <a href="https://instagram.com/aaronhoran/">
              <img src={contactImage} alt="" className="contact-photo" />
            </a>
          </div>
          <div className="contact-info">
            <h3 className="contact-name">Aaron Horan</h3>
            <div>
              <a href="tel:+15082595530">
                <Icon icon={faPhone} size="sm" /> 508-259-5530
              </a>
            </div>
            <div>
              <a href="https://instagram.com/aaronhoran/">
                <Icon icon={faInstagram} /> aaronhoran
              </a>
            </div>
          </div>
        </div>
        {/* <div className="contact-details">
          Photographer based out of New England. There is beauty in everything
          and I intend to capture all of it through the lens of my camera. I’m
          only at the beginning of my journey, but as I travel, meet new people,
          and share the many moments I’ll capture along the way I know I’ll be
          working towards a future I can be proud of.
          <br />
          <br />
          I’m very personable and enjoy working with people leading all kinds of
          lives. You can contact me about shooting events from weddings and
          other ceremonies to artistic endeavors.
        </div> */}
      </div>
    );
  }
}

export default Contact;
